export default __webpack_public_path__ + "static/Dont-Keep-content-simple-and-focused-9826fcdbde67b40dde0329b803b848c6.png";